
















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  ClassController,
  DropDownController,
  StudentController,
  TeacherController,
} from '@/services/request.service'
import GroupTransfer from '@/components/GroupTransfer.vue'
import cloneDeep from 'lodash/cloneDeep'

Component.registerHooks(['beforeRouteLeave'])

@Component({
  components: {
    GroupTransfer,
  },
})
export default class HomeroomEditor extends Vue {
  private classEditor: any
  private canLeave: any = false
  private formItemLayout: any = {
    labelCol: { span: 7 },
    wrapperCol: { span: 10 },
  }
  // private schoolYears: Array<any> = []
  private sections: Array<any> = []
  private students: Array<any> = []
  private teachers: Array<any> = []
  private selectedStudents: Array<any> = []
  private selectedHeadTeachers: Array<any> = []
  private saveLoading = false
  private groupTransferVisible = false
  private transferType = ''
  private transferTitle = ''
  private transferCandidate: Array<any> = []
  private transferSelected: Array<any> = []
  private allSchoolYears: any = []
  private unpassSchoolYears: any = []
  private dataLoading: any = false
  private confirmTransfer: boolean = false
  private newClassId: any = undefined
  private columns: Array<any> = [
    {
      title: this.$t('common.student'),
      dataIndex: 'studentName',
    },
    {
      title: this.$t('common.homeroom'),
      dataIndex: 'className',
    },
  ]
  private conflictStudents: any = []
  private decisions: any = []
  private selectedRowKeys: any = []

  private get locale(): string {
    return this.$store.state.locale
  }

  private get type(): any {
    return this.$route.query.type || 'add'
  }

  private get classId(): any {
    return this.$route.query.id || ''
  }

  private get schoolYears(): any {
    return this.type === 'edit' ? this.allSchoolYears : this.unpassSchoolYears
  }

  private beforeCreate(): void {
    this.classEditor = this.$form.createForm(this)
  }

  private created(): void {}

  private getDropDownInfo(schoolYearId?): void {
    Promise.all([
      DropDownController.getUnPassedSchoolYearList(),
      DropDownController.getSchoolYearList(),
    ])
      .then(res => {
        this.unpassSchoolYears = res[0].data
        this.$nextTick(() => {
          //   this.classEditor.setFieldsValue({
          //     ['schoolYearId']:
          //   })
        })
        if (!schoolYearId) {
          this.getTransferInfo(res[0].data[0].key)
        } else {
          this.getTransferInfo(schoolYearId)
        }
        this.allSchoolYears = res[1].data
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {})
  }

  private schoolYearChange(schoolYearId): void {
    this.getTransferInfo(schoolYearId)
  }

  private getClassDetail(): void {
    ClassController.detail(this.classId)
      .then(res => {
        const {
          classId,
          schoolYearName,
          sectionName,
          sectionEnName,
          students,
          assistants,
          headTeachers,
          ...classInfo
        } = res.data
        this.classEditor.setFieldsValue(classInfo)
        this.selectedStudents = students.map(item => {
          return {
            id: item.studentId,
            // title: (item.enName + ' ' + item.name).trim(),
            title: item.name,
          }
        })
        this.selectedHeadTeachers = headTeachers.map(item => {
          return {
            id: item.teacherId,
            title: (item.enName + ' ' + item.name).trim(),
          }
        })
        this.getDropDownInfo(classInfo.schoolYearId)
      })
      .catch(err => {
        console.error(err)
      })
  }

  private getTransferInfo(schoolYearId): void {
    this.dataLoading = true
    Promise.all([
      StudentController.getUnClassedStudentsGroupBySection(schoolYearId),
      TeacherController.getListAll(),
    ])
      .then(res => {
        this.sections = res[0].data
        let students = res[0].data.map(section => {
          return {
            title: this.locale === 'zh' ? section.sectionName : section.sectionEnName,
            id: section.sectionId,
            expand: false,
            children: section.students.map(student => {
              return {
                id: student.studentId,
                title: student.name,
              }
            }),
          }
        })
        const newStudentss = JSON.parse(JSON.stringify(students))
        const sectionId = this.classEditor.getFieldValue('sectionId')
        const section = this.sections.filter(section => sectionId === sectionId)[0]
        const title = this.locale === 'zh' ? section.value : section.enValue
        const id = sectionId
        const ids = students.map(section => section.id)
        const index = ids.indexOf(id)
        if (index !== -1) {
          // students[index].children = students[index].children.concat(this.selectedStudents)
        } else {
          students.push({
            title,
            id,
            expand: false,
            children: this.selectedStudents,
          })
        }
        this.students = students
        this.teachers = res[1].data.map(teacher => {
          return {
            id: teacher.teacherId,
            title: (teacher.enName + ' ' + teacher.name).trim(),
            selected: false,
          }
        })
      })
      .finally(() => {
        this.dataLoading = false
      })
  }

  private validateName(rule, value, callback): void {
    const form = this.classEditor
    const name = form.getFieldValue('name')
    const enName = form.getFieldValue('enName')
    if (enName || name) {
      if (enName && enName.length > 100) {
        callback(this.$t('setup.enterEnglishName'))
      } else if (name && name.length > 100) {
        callback(this.$t('setup.enterChineseName'))
      } else {
        callback()
      }
    } else {
      callback(this.$t('setup.emptyName'))
    }
  }

  private addPerson(type): void {
    this.groupTransferVisible = true
    this.transferType = type
    this.transferTitle = this.$t('mainClass.' + type) as string
    switch (type) {
      case 'student':
        this.transferCandidate = this.students
        this.transferSelected = this.selectedStudents
        break
      case 'headTeacher':
        this.transferCandidate = this.teachers
        this.transferSelected = this.selectedHeadTeachers
        break
    }
  }

  private getSelectedData(selectedData): void {
    switch (this.transferType) {
      case 'student':
        this.selectedStudents = cloneDeep(selectedData)
        break
      case 'headTeacher':
        this.selectedHeadTeachers = cloneDeep(selectedData)
        break
    }
  }

  private removeSelectedStudent(id): void {
    const index = this.selectedStudents.findIndex(item => item.id === id)
    this.selectedStudents.splice(index, 1)
  }

  private removeSelectedHeaderTeacher(id): void {
    const index = this.selectedHeadTeachers.findIndex(item => item.id === id)
    this.selectedHeadTeachers.splice(index, 1)
  }

  private cancel(): void {
    this.$router.back()
  }

  private saveClass(): void {
    this.saveLoading = true
    const form = this.classEditor
    form.validateFields((err: any, values: any) => {
      if (err) {
        this.saveLoading = false
        return
      } else {
        if (this.type === 'add') {
          const data = {
            ...values,
            studentIds: this.selectedStudents.map(item => item.id),
            headTeacherIds: this.selectedHeadTeachers.map(item => item.id),
          }
          ClassController.add(data)
            .then(res => {
              if (res.data.success) {
                if (res.data.force) {
                  this.confirmTransfer = true
                  this.conflictStudents = res.data.conflictStudents
                  this.selectedRowKeys = res.data.conflictStudents.map(item => item.studentId)
                  this.newClassId = res.data.classId
                  // this.confirmEdit()
                } else {
                  this.$message.success(this.$tc('common.saveSuccess'))
                  this.canLeave = true
                  this.$route.meta!.refresh = true
                  this.$router.replace({ name: 'homeroom' })
                }
              } else {
                const name = form.getFieldValue('name')
                form.setFields({
                  ['name']: {
                    value: name,
                    errors: [{ message: res.data.resMsg, field: 'name' }],
                  },
                })
              }
            })
            .catch(err => {
              console.error(err)
            })
            .finally(() => {
              this.saveLoading = false
            })
        } else if (this.type === 'edit') {
          const data = {
            ...values,
            classId: this.classId,
            studentIds: this.selectedStudents.map(item => item.id),
            headTeacherIds: this.selectedHeadTeachers.map(item => item.id),
          }
          ClassController.update(data)
            .then(res => {
              if (res.data.success) {
                if (res.data.force) {
                  this.confirmTransfer = true
                  this.conflictStudents = res.data.conflictStudents
                  this.selectedRowKeys = res.data.conflictStudents.map(item => item.studentId)
                } else {
                  this.$message.success(this.$tc('common.saveSuccess'))
                  this.canLeave = true
                  this.$route.meta!.refresh = true
                  this.$router.replace({ name: 'homeroom' })
                }
              } else {
                const name = form.getFieldValue('name')
                form.setFields({
                  ['name']: {
                    value: name,
                    errors: [{ message: res.data.resMsg, field: 'name' }],
                  },
                })
              }
            })
            .catch(err => {
              console.error(err)
            })
            .finally(() => {
              this.saveLoading = false
            })
        }
      }
    })
  }

  // 二次确认
  private confirmEdit(): void {
    const decisions = this.conflictStudents
      .filter(item => this.selectedRowKeys.includes(item.studentId))
      .map(item => {
        return {
          ...item,
          force: true,
          classId: this.newClassId || this.classId,
        }
      })
    const form = this.classEditor
    form.validateFields((err: any, values: any) => {
      const data = {
        ...values,
        classId: this.newClassId || this.classId,
        studentIds: this.selectedStudents.map(item => item.id),
        headTeacherIds: this.selectedHeadTeachers.map(item => item.id),
        force: true,
        decisions,
      }
      ClassController.update(data).then(res => {
        if (res.data.success) {
          this.$message.success(this.$tc('common.saveSuccess'))
          this.canLeave = true
          this.$route.meta!.refresh = true
          this.$router.replace({ name: 'homeroom' })
        } else {
          this.confirmTransfer = false
          const name = form.getFieldValue('name')
          form.setFields({
            ['name']: {
              value: name,
              errors: [{ message: res.data.resMsg, field: 'name' }],
            },
          })
        }
      })
    })
  }

  private handleCancel(): void {
    this.confirmTransfer = false
  }
  private onSelectChange(selectedRowKeys): void {
    this.selectedRowKeys = selectedRowKeys
  }

  private beforeRouteLeave(to, from, next): void {
    if (!this.$store.state.forceBack) {
      if (!this.canLeave) {
        this.$confirm({
          title: this.$t('common.unsaveConfirm'),
          onOk: () => {
            next()
          },
          onCancel: () => {
            next(false)
          },
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }

  @Watch('$route', { immediate: true })
  private onRouteChange(to): void {
    to.meta.routerName = to.query.type === 'edit' ? 'editHomeroom' : 'addHomeroom'
    if (this.type === 'edit') {
      this.getClassDetail()
    } else {
      this.getDropDownInfo()
    }
  }
}
